import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const SendArrowSvg = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='26' height='25' viewBox='0 0 26 25' fill='none'>
    <path
      d='M23.8722 1.82373L12.2252 13.4708'
      stroke='url(#paint0_linear_9843_9572)'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M23.8722 1.82373L16.4605 23.0002L12.2252 13.4708L2.69577 9.23549L23.8722 1.82373Z'
      stroke='url(#paint1_linear_9843_9572)'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_9843_9572'
        x1='12.2252'
        y1='1.82373'
        x2='24.299'
        y2='2.28431'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_9843_9572'
        x1='2.69577'
        y1='1.82373'
        x2='24.6481'
        y2='2.66115'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
    </defs>
  </svg>
);

export const SendArrowIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={SendArrowSvg} {...props} />
);
